export default "__VITE_ASSET___Bn5D1A8__"